export default __webpack_public_path__ + "static/media/remote-up.57423c2d.png";